import {HttpException} from "./http.exception.js";

/**
 * 422 Unprocessable Entity Exception
 */
export class UnprocessableEntityException extends HttpException {
    constructor(message: string = "Unprocessable Entity", errorBody?: unknown, cause?: Error) {
        super(422, message, errorBody, cause);
    }
}
